import { Box, Modal, Typography } from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
import { changeOwner, getAdmins } from "../api/admins";
import { getGroupAdminInfo, getGroupsUsers } from "../api/group";
import replacePic from "../assets/image/replacement.png";
import AutoComplate from "./autocomplete/autoComplate";
import InputForm from "./inputForm";

export default function ReplacementGroupLeader({
  show,
  setShow,
  groupName,
  groupId,
  setDataAdmin,
}) {
  // console.log(groupId);
  const [Options, setOptions] = useState();
  const [userInfo, setUserInfo] = useState();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setShow(false);
    setOpen(false);
  };
  useEffect(() => {
    if (show === true) {
      setOpen(true);
      getAdmins(`?groupName=${groupName}`)
        .then((x) => setOptions(x))
        .catch((z) => console.log(z));
    }
  }, [show]);
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      //   sx={{}}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 750,
          height: 350,
          bgcolor: "white",
          boxShadow: 24,
          p: 5,
          borderRadius: "23px",
          ":focus-visible": {
            outline: "none !important",
            border: "none !important",
          },
        }}
      >
        <Box display="flex" alignItems="center" gap="20px">
          <Box width="40%" borderLeft="1px solid #98C2CB" height={"350px"}>
            <img src={replacePic} />
          </Box>
          <Box display="grid" height="300px" pl="20px">
            <Box>
              <Typography fontSize="18px">{"تعویض مسئول گروه"}</Typography>
              <Typography mt="10px" color="var(--emr-disable)" fontSize="16px">
                {"۱. مسئول مورد نظر خود را از منوی پایین انتخاب کنید."}
              </Typography>
              <Typography mt="5px" color="var(--emr-disable)" fontSize="16px">
                {
                  "۲. پس از انتخاب مسئول جدید، دسترسی مسئول پیشین به نرم‌افزار به طور کامل متوقف می‌گردد."
                }
              </Typography>
              <Typography mt="5px" color="var(--emr-disable)" fontSize="16px">
                {
                  "۳. لازم به ذکر است که شخص مورد نظر باید حتماً یکبار از طریق سامانه به ثبت نام کند."
                }
              </Typography>
            </Box>
            <Box mx="20px" my="20px">
              {/* <InputForm
              value={value}
              setValue={setValue}
                Options={Options}
                placeholder="مسئول گروه را انتخاب کنید."
                lable="مسئول گروه"
              /> */}
              <AutoComplate
                value={userInfo}
                setValue={setUserInfo}
                onChange={(e) => console.log(e)}
                label="مسئول گروه"
                placeholder="مسئول گروه را انتخاب کنید."
                options={Options}
              />
            </Box>
            <button
              onClick={() => {
                changeOwner(groupId, userInfo?.id)
                  .then(() => {
                    getGroupAdminInfo(userInfo?.id)
                      .then((x) => {
                        setDataAdmin(x);
                        setOpen(false);
                      })
                      .catch((z) => console.log(z));
                  })
                  .catch(() => {});
              }}
              style={{
                borderRadius: "7px",
                background: "#F05542",
                border: "none",
                padding: "10px 0px",
                marginTop: "5px",
                fontSize: "20px",
                color: "white",
              }}
            >
              {"تایید انتقال مالکیت به مسئول جدید"}
            </button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
